module.exports = __webpack_public_path__ + "fonts/8d35ed5a4c7395091c6cfec244ea4095.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/vehicle.svg
// module id = 622
// module chunks = 0